import Marionette from "backbone.marionette";

export default Backbone.Model.extend({
    urlRoot: "api/search/index.php"
});


//////////////////
// WEBPACK FOOTER
// ./app/models/searchModel.js
// module id = 176
// module chunks = 0